import React from 'react';

export type IconName =
  | 'briefcase'
  | 'check'
  | 'chevron-right'
  | 'chevron-down'
  | 'flame'
  | 'medal'
  | 'shield'
  | 'sparkles'
  | 'target'
  | 'trophy'
  | 'user'
  | 'users'
  | 'bell'
  | 'search'
  | 'star'
  | 'arrow-up'
  | 'arrow-down'
  | 'lightning'
  | 'document'
  | 'lock'
  | 'eye'
  | 'plus';

interface IconProps extends React.SVGAttributes<SVGSVGElement> {
  name: IconName;
  size?: number;
  strokeWidth?: number;
}

const PATHS: Record<IconName, React.ReactNode> = {
  briefcase: <><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M3 12h18"/></>,
  check: <polyline points="4 12 10 18 20 6"/>,
  'chevron-right': <polyline points="9 6 15 12 9 18"/>,
  'chevron-down': <polyline points="6 9 12 15 18 9"/>,
  flame: <path d="M12 3c2 4 6 5 6 10a6 6 0 0 1-12 0c0-3 2-4 3-6 1 2 2 3 3 0z"/>,
  medal: <><circle cx="12" cy="14" r="6"/><path d="M8 3l4 6 4-6"/></>,
  shield: <path d="M12 3l8 3v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3z"/>,
  sparkles: <><path d="M12 3l1.5 4 4 1.5-4 1.5L12 14l-1.5-4-4-1.5 4-1.5z"/><path d="M19 14l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/></>,
  target: <><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1"/></>,
  trophy: <><path d="M8 4h8v6a4 4 0 0 1-8 0V4z"/><path d="M8 6H5v2a3 3 0 0 0 3 3"/><path d="M16 6h3v2a3 3 0 0 1-3 3"/><path d="M10 16h4v4h-4z"/></>,
  user: <><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/></>,
  users: <><circle cx="9" cy="8" r="4"/><path d="M2 21c0-4 3-7 7-7s7 3 7 7"/><path d="M16 4a4 4 0 0 1 0 8"/><path d="M22 21c0-3-2-5-5-6"/></>,
  bell: <><path d="M6 16V11a6 6 0 0 1 12 0v5l1 2H5l1-2z"/><path d="M10 20a2 2 0 0 0 4 0"/></>,
  search: <><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></>,
  star: <polygon points="12 3 14.5 9 21 9.5 16 14 17.5 21 12 17.5 6.5 21 8 14 3 9.5 9.5 9"/>,
  'arrow-up': <><path d="M12 19V5"/><polyline points="6 11 12 5 18 11"/></>,
  'arrow-down': <><path d="M12 5v14"/><polyline points="6 13 12 19 18 13"/></>,
  lightning: <polyline points="13 2 4 14 11 14 10 22 20 10 13 10"/>,
  document: <><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="14 3 14 9 20 9"/></>,
  lock: <><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></>,
  eye: <><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></>,
  plus: <><path d="M12 5v14"/><path d="M5 12h14"/></>,
};

export const Icon: React.FC<IconProps> = ({ name, size = 18, strokeWidth = 1.75, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...rest}
  >
    {PATHS[name]}
  </svg>
);
